import * as s from "pages/recorders/RecordersStyled";
import BigButton from "components/atoms/buttons/BigButton";
import { ReactComponent as UpdatedFailedIcon } from "assets/icons/update_failed.svg";
import { FiAlertTriangle } from "react-icons/fi";
import {
  FirmwareUpdateInfoResult,
  FIRMWARE_UPDATE_STEP,
} from "api/interfaces/settingsInterface.interface";
import StepBar from "components/atoms/step/StepBar";
import { COLORS } from "styles/colors";
import { updateErrorMsg } from "utils/firmwareUtil";

export default function FirmwareFailed({
  data,
  percent,
  onClickCancel,
  onClickUpdate,
  failedReason,
  disabledUpdate,
  onlineStatus,
}: {
  data: FirmwareUpdateInfoResult;
  percent: number;
  onClickCancel: () => void;
  onClickUpdate: () => void;
  failedReason: string;
  disabledUpdate: boolean;
  onlineStatus: boolean;
}) {
  return (
    <s.UpdateFirmwareStyled.Wrapper status={FIRMWARE_UPDATE_STEP.FAILED}>
      <s.UpdateFirmwareStyled.UpdateStatus>
        {updateErrorMsg[Math.floor(percent / 20)]}
      </s.UpdateFirmwareStyled.UpdateStatus>
      <StepBar
        percent={percent}
        steps={5}
        backgroundColor={COLORS.VALIDATERED}
        animation={false}
      />

      <s.UpdateFirmwareStyled.InfoWrapper>
        <s.UpdateFirmwareStyled.Version.Label
          status={FIRMWARE_UPDATE_STEP.INTRO}
        >
          <span>Current Version</span>
          <b>Version {data.currentVersion}</b>
        </s.UpdateFirmwareStyled.Version.Label>
        <UpdatedFailedIcon />
        <s.UpdateFirmwareStyled.Version.Label
          status={FIRMWARE_UPDATE_STEP.FAILED}
        >
          <span>Updated to</span>
          <b>Version {data.updateVersion}</b>
        </s.UpdateFirmwareStyled.Version.Label>
      </s.UpdateFirmwareStyled.InfoWrapper>
      <s.UpdateFirmwareStyled.Reason>
        <FiAlertTriangle className="alert-icon" size={40} />
        <h3>Firmware update failed, please address the issue and try again.</h3>
        <p>
          {onlineStatus
            ? failedReason
            : "The recorder is not online. Please check the recorder status and try again."}
        </p>
      </s.UpdateFirmwareStyled.Reason>
      <s.UpdateFirmwareStyled.Buttons>
        <BigButton
          onClickBtn={onClickCancel}
          label="Cancel"
          buttonType="cancel"
          data-testid="recorders-edit-step-button-click-cancel"
        />

        <BigButton
          onClickBtn={onClickUpdate}
          label="Try Again"
          disabled={disabledUpdate}
          data-testid="recorders-edit-step-button-click-update"
        />
      </s.UpdateFirmwareStyled.Buttons>
    </s.UpdateFirmwareStyled.Wrapper>
  );
}
